import { render } from "./TGPrivatePage.vue?vue&type=template&id=54951f3c"
import script from "./TGPrivatePage.vue?vue&type=script&lang=js"
export * from "./TGPrivatePage.vue?vue&type=script&lang=js"

import "./TGPrivatePage.vue?vue&type=style&index=0&id=54951f3c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__